import {IUser} from "../../../store/reducers/userReducer/userReducerTypes";
import {IManager} from "../../../store/reducers/personnelManagementReducer/personnelManagementReducerTypes";

export const DisplayFullName = (user: IUser, type: 'full' | 'short' = 'full'): string => {
  const userFullNameParts = [user.firstName, user.lastName];

  if (type === 'short')
    return `${user.firstName} ${user.lastName && `${user.lastName.slice(0, 1)}.`} ${user.middleName && (user.middleName?.slice(0, 1) + ".")}`

  if (user.middleName)
    userFullNameParts.push(user.middleName);

  return userFullNameParts.join(' ');
}

export const DisplayManagerFullName = (manager: IManager): string => {
  const managerFullNameParts = [manager.name, manager.lastName];

  //  TODO need for middlename?
  // if (manager.middleName)
  //   managerFullNameParts.push(manager.middleName);

  return managerFullNameParts.join(' ');
}